export const ADMIN = "1";
export const MANAGER = "2";
export const PERSONEL = "3";